import { PublicClientApplication, type AuthenticationResult } from '@azure/msal-browser';

const LOGIN_SCOPES = ['openid', 'profile', 'email'];

let instance: PublicClientApplication | null = null;

export function msal(): PublicClientApplication {
  if (!instance) {
    instance = new PublicClientApplication({
      auth: {
        clientId: import.meta.env.VITE_ENTRA_SPA_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: `${window.location.origin}/login`,
      },
      cache: { cacheLocation: 'sessionStorage' },
    });
  }
  return instance;
}

/** Must run once before render. Returns the ID token when returning from the Entra redirect. */
export async function completeRedirect(): Promise<string | null> {
  const app = msal();
  await app.initialize();
  const result: AuthenticationResult | null = await app.handleRedirectPromise();
  return result?.idToken ?? null;
}

export function startLogin(): Promise<void> {
  return msal().loginRedirect({ scopes: LOGIN_SCOPES, prompt: 'select_account' });
}

export function startLogout(): Promise<void> {
  return msal().logoutRedirect();
}
